import { createStyles, StylesClasses } from '@utils/styles'

const styles = createStyles({
  outerWrapper: {
    display: 'flex',
    alignItems: 'stretch',
    gap: '32px',
    flexGrow: 'inherit',
    minHeight: '100%',
    justifyContent: 'space-between',
    flexDirection: {
      xs: 'column',
      sm: 'row',
    },
  },
  mainContent: {
    display: 'flex',
    gap: '80px',
    flexDirection: { xs: 'column', md: 'row' },
    flexBasis: { xs: 'unset', sm: '64.1%' },
  },
  leftContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    flex: 1,
  },
  chip: {
    borderRadius: '4px',
  },
  image: {
    width: '100%',
    maxWidth: '824px',
    height: { xs: '250px', md: '400px' },
    overflow: 'hidden',
    borderRadius: '8px',
    marginBottom: { md: '32px' },
  },
  tagsContainer: {
    display: 'flex',
    gap: 1.5,
    flexWrap: 'wrap',
  },
  rightBox: {},
  documentWrapper: {
    '& p': {
      color: 'common.white',
    },
    '& p:empty': {
      display: 'none !important',
      margin: 0,
      padding: 0,
    },
    '& a': {
      color: 'primary.main',
      textDecoration: 'underline',
      fontWeight: '600',
    },
  },
  cardsWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '16px',
  },
  bulletPointsTypographyWrapper: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    gap: { xs: '0.5rem', md: '2rem' },
    alignItems: { md: 'center' },
    width: '100%',
    color: 'common.white',
    flexWrap: 'wrap',
  },
  bulletPoint: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    whiteSpace: { md: 'nowrap' },
    color: 'common.white',
  },

  actionButton: {
    backgroundColor: 'common.white',
    color: 'common.black',
    '&:hover': {
      backgroundColor: '#e6e6e6 !important',
    },
  },
  bulletPointsContainer: {},
  listItem: {
    display: {
      xs: 'none',
      sm: 'flex',
    },
    alignItems: 'center',
    gap: 1.5,
  },
  childrenWrapper: {},
})

export type StylesClassNames = StylesClasses<typeof styles>

export default styles
